<div>
    <form nz-form #clientMasterPage="ngForm">
        <div nz-row class="my-box" nzGutter="5">
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Name</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Client Name is Required">
                        <input nz-input autocomplete="off" name="name" type="text" placeHolder="Enter Client Name"
                            [(ngModel)]="data.NAME" required />
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Address</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Address is Required">
                        <textarea nz-input [nzAutosize]="{ minRows: 2, maxRows: 6 }" name="clientAddress"
                            placeHolder="Enter Client Address" [(ngModel)]="data.INDUSTRY_ADDRESS" required></textarea>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="16">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>City</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="City is Required">
                        <input nz-input autocomplete="off" name="clientCity" type="text" placeHolder="Enter Client City"
                            [(ngModel)]="data.INDUSTRY_CITY" required />
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Pincode</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Pincode is Required">
                        <input nz-input name="clientPincode" type="number" placeHolder="Enter Pincode"
                            [(ngModel)]="data.INDUSTRY_PINCODE" pattern="[1-9]{1}[0-9]{5}$" required />
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="16">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Email</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Client's Email is Required">
                        <input nz-input autocomplete="off" name="emailId" type="text" placeHolder="Enter Client's Email"
                            [(ngModel)]="data.EMAIL_ID" pattern="[a-z0-9._%+-]+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$" required />
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Mobile No.</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Mobile No. is Required">
                        <input nz-input autocomplete="off" name="mobileNo" type="number" placeHolder="Enter Mobile No."
                            [(ngModel)]="data.MOBILE_NO" pattern="[6-9][0-9]{9}$" required />
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>

        <div nz-row class="my-box" nzGutter="5">
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Industry Name</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Client's Industry Name is Required">
                        <input nz-input autocomplete="off" name="industryName" type="text"
                            placeHolder="Enter Client's Industry Name" [(ngModel)]="data.INDUSTRY_NAME" required />
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>

        <div nz-row class="my-box" nzGutter="5">
            <div nz-col nzSpan="16">
                <nz-form-item>
                    <nz-form-label nzNoColon>Billing Mode</nz-form-label>

                    <nz-form-control>
                        <nz-radio-group name="billingMode" [(ngModel)]="data.BILLING_MODE">
                            <label nz-radio nzValue="F">Fixed</label>
                            <label nz-radio nzValue="H">Hourly</label>
                        </nz-radio-group>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzNoColon>Status</nz-form-label>

                    <nz-form-control>
                        <nz-switch name="isActive" [(ngModel)]="data.IS_ACTIVE"></nz-switch>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
    </form>
</div>

<div class="footer">
    <button type="button" nz-button class="ant-btn" style="margin-right: 8px;"
        (click)="close(clientMasterPage)"><span>Cancel</span></button>
    <button type="button" class="ant-btn ant-btn-primary" nz-button [nzLoading]="isSpinning" *ngIf="data.ID"
        (click)="save(false)"><span>Update & close</span></button>
    <button type="button" class="ant-btn ant-btn-primary" *ngIf="!data.ID" nz-button [nzLoading]="isSpinning"
        nz-dropdown [nzDropdownMenu]="menu" (click)="save(false)"><span>Save & Close</span></button>
    <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
            <li nz-menu-item class="menuc" style="border-radius: 4px;background-color: #40a9ff;">
                <a (click)="save(true)">Save & New</a>
            </li>
        </ul>
    </nz-dropdown-menu>

    <!-- <button type="button" nz-button class="ant-btn" style="margin-right: 8px;"
        (click)="resetDrawer(clientMasterPage)"><span>Reset</span></button> -->
</div>